<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$emit('closeAddFileResponse')">
            {{$t('com.file.show-interpellation.response-as-file')}}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{$t('com.file.send-meeting-regarding.files-label')}}</label>
            <InputFileComponent @change="onFileResponseChange" />
            <section class="checkbox-wrapper" @click="toogleIsSendNotifyToAuthor()">
                <CheckBoxButtonSingleUnchecked
                    :value="1"
                    :id="'response-notify-author'"
                    :checked="isNotifyAuthor"/>
                <label class="checkbox">{{$t('com.file.interpellation.is-send-notify-to-author')}}</label>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$emit('closeAddFileResponse')">
                {{$t('com.global.cancel')}}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @save="saveFileResponse" :disabled="!responseFile || isLoading">
                {{$t('com.global.send')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>

<script>
import InputFileComponent from "../../../../BasicControls/InputFileComponent.vue";
import CheckBoxButtonSingleUnchecked from "../../../../BasicControls/CheckButtonSingleUnchecked.vue";
import InterpellationService from "../../../../../services/interpellation.service";
import AlertHelper from '@/helpers/alerts.helper.js';

export default {
    name: "AddFileResponseModal",
    emits: ["closeAddFileResponse", "fileResponseAdded"],
    components: {
        InputFileComponent,
        CheckBoxButtonSingleUnchecked,
    },
    props: {
        inter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            responseFile: null,
            isNotifyAuthor: true,
            isLoading: false,
        };
    },
    methods: {
        toogleIsSendNotifyToAuthor() {
            this.isNotifyAuthor = !this.isNotifyAuthor;
        },
        onFileResponseChange(event) {
            const files = event?.target?.files ?? [];
            this.responseFile = files.length > 0 ? files[0] : null;
        },
        checkMimeType(type) {
            if (type != "application/pdf" && type != "image/jpeg" && type != "image/jpg" &&
                type != "image/png" && type != "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
                type != "text/plain" && type != "application/vnd.oasis.opendocument.text" && type != "application/vnd.oasis.opendocument.spreadsheet" &&
                type != "application/vnd.ms-excel" && type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && type != "application/rtf" && type != "application/msword") {
                return false;
            } else {
                return true;
            }
        },
        async saveFileResponse() {
            if (!this.responseFile)
                return;

            if (this.responseFile.size > 30000000) {
                this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-size-info') + " 30MB", this.$t('com.global.error')));
                return;
            }

            if (!this.checkMimeType(this.responseFile.type)) {
                this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-type-info') + " PDF, DOC, DOCX, JPG, PNG, RTF, XLS, TXT, ODT, ODS", this.$t('com.global.error')));
                return;
            }

            try {
                this.isLoading = true;
                const formData = new FormData();
                formData.append('files[0]', this.responseFile);
                formData.append("id", this.inter.id);
                formData.append("lid", this.inter.lid);
                formData.append("response", true);
                formData.append("isSentNotifyToAuthor", this.isNotifyAuthor);

                const result = (await InterpellationService.addInterpellationAttachement(formData)).data;
                if (Object.keys(result).length > 0) {
                    this.$emit("fileResponseAdded", result);
                    this.$emit("closeAddFileResponse");
                }
            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';

    .checkbox {
        font-weight: normal;
        font-size: 16px;
        line-height: 144%;
        color: #333956;
        margin-left: 12px;
        margin-bottom: 0px;
        padding-left: 24px;
        z-index: 0;
        cursor: pointer;
    }

    .checkbox-wrapper {
        display: flex;
        padding: 5px;
        float: left;
        margin-top: 8px;
    }
</style>
